<template>
    <el-radio-button
        :label="label"
        :name="name"
        :disabled="disabled"
        data-testid="input-radio-button"
        class="base-radio-button"
        v-bind="attrs"
        v-on="listeners"
    >
        <slot />
    </el-radio-button>
</template>

<script setup lang="ts">
import { RadioButton as ElRadioButton } from 'element-ui'
import { useAttrs, useListeners } from 'vue'

const listeners = useListeners()
const attrs = useAttrs()

withDefaults(
    defineProps<{
        label?: string | number
        name?: string
        disabled?: boolean
    }>(),
    {
        name: undefined,
        label: undefined,
        disabled: false
    }
)
</script>

<style lang="scss">
    .el-radio-button.base-radio-button {
        @apply outline-none;
        .el-radio-button__inner {
            @apply px-3 py-1-5 min-h-8 flex items-center;
        }
        &:focus:not(.is-focus):not(:active):not(.is-disabled) {
            @apply outline-none shadow-none;
        }
        &:not(.is-active):not(.is-disabled) .el-radio-button__inner:hover {
            @apply text-active-elements;
        }
        &.is-active {
            .el-radio-button__inner {
                @apply bg-active-elements border-active-elements text-white;
                box-shadow: -1px 0 0 0 var(--ui-lines);
            }
        }
    }
    [dir='rtl'], .rtl {
        .el-radio-button.base-radio-button {
            &:first-child {
                .el-radio-button__inner {
                    border-left: none;
                    border-right: 1px solid var(--ui-lines);
                    border-radius: 0 4px 4px 0;
                }
            }
            &:last-child {
                .el-radio-button__inner {
                    border-left: 1px solid var(--ui-lines);
                    border-radius: 4px 0 0 4px;
                }
            }
        }
    }
</style>
